import React from "react";
import { Controller } from "react-hook-form";
import { FontEnum } from "../../utils/enums/FontEnum";

const ControllerCheckbox = ({
    name,
    control,
    labelText,
    defaultValue,
    disabled = false,
    onChange,
}) => {

    return (
        <Controller
            name={name}
            defaultValue={defaultValue || false}
            control={control}
            render={({ field, fieldState }) => (
                <label style={styles.labelContainer}>
                    <input
                        {...field}
                        id={name}
                        type="checkbox"
                        style={styles.inputStyle}
                        checked={field.value}
                        disabled={disabled}
                        onChange={(e) => {
                            field.onChange(e);
                            if (onChange) {
                                onChange(e);
                            };
                        }}
                    />

                    <span style={styles.labelText}>
                        {labelText}
                    </span>
                </label>
            )}
        />
    );
};


export default ControllerCheckbox;


const styles = {
    labelContainer: {
        display: 'flex',
        width: 'fit-content',
        alignItems: 'center',
        cursor: "pointer",
        gap: "8px",
    },
    inputStyle: {
        width: "20px",
        height: "20px",
        cursor: "pointer",
    },
    labelText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000"
    }
}